import { REACT_QUERY_KEYS } from 'common'
import { TEntity, TLanguage } from 'contexts/app-context/types'
import { getFAQs } from 'pages/frequent-questions/repository/frequent-questions'

import { queryOptions } from '@tanstack/react-query'

import { GetFAQsResponse } from '../../types/FrequentQuestions.types'

interface GetFaqsQueryParams {
  queryText: string
  language: TLanguage
  userSelectedEntity: TEntity
}

export const getFaqsQueryKey = ({
  queryText,
  language,
  userSelectedEntity,
}: GetFaqsQueryParams) => [REACT_QUERY_KEYS.FAQ, queryText, language, userSelectedEntity]

export const getFaqsQueryOptions = ({
  queryText,
  language,
  userSelectedEntity,
}: GetFaqsQueryParams) =>
  queryOptions({
    queryKey: getFaqsQueryKey({ queryText, language, userSelectedEntity }),
    queryFn: () => getFAQs(queryText, language, userSelectedEntity),
    staleTime: 1000 * 60 * 2,
    gcTime: 1000 * 60 * 6,
  })

export type { GetFaqsQueryParams, GetFAQsResponse }
